import {Injectable} from '@angular/core';

/**
 * Translations for membership statuses.
 */
@Injectable()
export class MembershipStatusTranslationsService {
  public i18nMemberStatus: any = $localize`:@@general.status.member:Member`;
  public i18nLockedStatus: any = $localize`:@@general.status.locked:Locked`;
  public i18nTerminatedStatus: any = $localize`:@@general.status.terminated:Terminated`;
  public i18nWillLeaveStatus: any = $localize`:@@general.status.willLeave:Will leave`;
  public i18nWillEnterStatus: any = $localize`:@@general.status.willEnter:Will enter`;
  public i18nHasLeftStatus: any = $localize`:@@general.status.hasLeft:Has left`;
  public i18nCustomerHasMembership: any = $localize`:@@general.status.customerHasMembership:Customer has membership`;
  public i18nCampaiTransferInitiated: any = $localize`:@@general.status.campaiTransferInitiated:Campai transfer process has successfully initiated.`;
  public i18nCampaiTransferFailed: any = $localize`:@@general.status.campaiTransferFailed:Campai transfer process has failed to initiate.`;
  public i18nCampaiIdCopied: any = $localize`:@@general.status.campaiIdCopied:Campai ID has been copied to the clipboard and can be now pasted into the campai member profile.`;
  constructor() { }
}
